module.exports = __webpack_public_path__ + "assets/img/notupdate.0fded722.png";